import React, { useState } from "react";

interface SortDropdownProps {
  onSortChange: (sortBy: string) => void;
  currentSortBy?: string;
}

const SortDropdown: React.FC<SortDropdownProps> = ({ onSortChange, currentSortBy = "DepartureTime" }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  // Map API values to display names
  const mapApiValueToDisplayName = (apiValue: string): string => {
    switch (apiValue) {
      case "DepartureTime":
        return "Departure Time";
      case "FlightNumber":
        return "Flight Number";
      case "Route":
        return "Route";
      default:
        return "Departure Time";
    }
  };

  const selectedDisplayName = mapApiValueToDisplayName(currentSortBy);

  return (
    <div className="relative">
      <button
        className="flex items-center gap-2 p-3 bg-[#737E9A] rounded-lg"
        onClick={toggleDropdown}
      >
        <i className="st-options text-white text-xs"></i>
      </button>

      {isDropdownOpen && (
        <div className="absolute top-full right-0 mt-2 z-50 bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-56 min-w-max max-w-[90vw] overflow-auto">
          <ul className="px-4 text-sm text-gray-700" role="menu">
            <p className="py-4 border-b border-gray-200 font-semibold text-grease-100">
              Sort By
            </p>
            {["Departure Time", "Route", "Flight Number"].map((option) => {
              const isSelected = option === selectedDisplayName;
              return (
                <li key={option} role="menuitem">
                  <button
                    className={`flex items-center justify-between gap-2 py-2 text-lightgray-200 text-sm w-full text-left ${
                      isSelected ? "font-semibold text-grease-100" : ""
                    }`}
                    onClick={() => {
                      onSortChange(option);
                      setIsDropdownOpen(false);
                    }}
                  >
                    <span>{option}</span>
                    {isSelected && (
                      <svg
                        className="w-4 h-4 text-[#FFD700]"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
